'use client'

import { useSyncExternalStore } from 'react'

const subscribe = () => () => {}
const getClientSnapshot = () => true
const getServerSnapshot = () => false

/**
 * Returns `true` once the component has mounted on the client. SSR-safe via
 * useSyncExternalStore, which guarantees the server render returns `false`
 * and the first client render flips to `true` without a layout-effect
 * cascade. Use this for theme-dependent content, browser-only APIs, etc.
 *
 * Prefer this over `const [mounted, setMounted] = useState(false); useEffect(() => setMounted(true), [])`
 * — that pattern triggers `react-hooks/set-state-in-effect`.
 */
export function useMounted(): boolean {
  return useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot)
}
